module.exports = __webpack_public_path__ + "static/media/pic-sl6.831059b0.png";